import {Component, OnInit} from '@angular/core';
import {ComponentPortal} from '@angular/cdk/portal';
import {ActivatedRoute, Router} from '@angular/router';
import * as moment from 'moment';
import {WidgetType} from './widget';
import {SessionService} from '../../session/session.service';
import {Cliente} from '../../model/personas/cliente.model';
import {HashService} from '../../services/hash-service';
import {
    SolicitudesPendientesValidarWidgetComponent
} from './solicitudes-pendientes-validar-widget/solicitudes-pendientes-validar-widget.component';
import {
    SolicitudesIntraoralesPendientesValidarWidgetComponent
} from './solicitudes-intraorales-pendientes-validar-widget/solicitudes-intraorales-pendientes-validar-widget.component';
import {SolicitudesValidadasWidgetComponent} from './solicitudes-validadas-widget/solicitudes-validadas-widget.component';
import {
    SolicitudesIntraoralesValidadasWidgetComponent
} from './solicitudes-intraorales-validadas-widget/solicitudes-intraorales-validadas-widget.component';
import {
    SegmentacionesValidadasWidgetComponent
} from './segmentaciones-validadas-widget/segmentaciones-validadas-widget.component';
import {PiezasProduccionWidgetComponent} from './piezas-produccion-widget/piezas-produccion-widget.component';
import {PiezasEnTransitoWidgetComponent} from './piezas-en-transito-widget/piezas-en-transito-widget.component';
import {IncidenciasWidgetComponent} from './incidencias-widget/incidencias-widget.component';
import {PedidosRechazadosWidgetComponent} from './pedidos-rechazados-widget/pedidos-rechazados-widget.component';
import {
    SolicitudesRechazadasWidgetComponent
} from './solicitudes-rechazadas-widget/solicitudes-rechazadas-widget.component';
import {
    SolicitudesIntraoralesRechazadasWidgetComponent
} from './solicitudes-intraorales-rechazadas-widget/solicitudes-intraorales-rechazadas-widget.component';

/** Un indicador de la vista general: el widget que cuenta y a dónde lleva al pulsarlo. */
interface Indicador {
    portal: ComponentPortal<any>;
    link?: string;
}

interface GrupoIndicadores {
    titulo: string;
    indicadores: Indicador[];
}

/**
 * Los cuatro grupos de la maqueta (indicadores.php), repartidos en filas como pidió el usuario el
 * 2026-10-09: arriba las dos de validación, debajo producción e incidencias, y al final las
 * últimas facturas. Fijos: hasta octubre de 2026 era una rejilla de widgets que el cliente
 * colocaba arrastrando; el usuario decidió dejarla como la maqueta.
 */
const FILAS: { titulo: string, widgets: WidgetType[] }[][] = [
    [
        {
            titulo: 'Diseños pendientes de validación',
            widgets: [SolicitudesPendientesValidarWidgetComponent, SolicitudesIntraoralesPendientesValidarWidgetComponent]
        },
        {
            titulo: 'Diseños validados',
            widgets: [SolicitudesValidadasWidgetComponent, SolicitudesIntraoralesValidadasWidgetComponent, SegmentacionesValidadasWidgetComponent]
        },
    ],
    [
        {
            titulo: 'Producción / En tránsito',
            widgets: [PiezasProduccionWidgetComponent, PiezasEnTransitoWidgetComponent]
        },
        {
            titulo: 'Incidencias / Rechazo de piezas',
            widgets: [IncidenciasWidgetComponent, PedidosRechazadosWidgetComponent, SolicitudesRechazadasWidgetComponent,
                SolicitudesIntraoralesRechazadasWidgetComponent]
        },
    ],
];

@Component({
    selector: "app-inicio",
    templateUrl: "./inicio.component.html",
    styleUrls: ["./inicio.component.scss"]
})
export class InicioComponent implements OnInit {
    public readonly filas: GrupoIndicadores[][] = FILAS.map(fila => fila.map(grupo => ({
        titulo: grupo.titulo,
        indicadores: grupo.widgets.map(widget => ({portal: new ComponentPortal(widget), link: widget.link}))
    })));

    constructor(private _session: SessionService, private router: Router, private route: ActivatedRoute, private hashService: HashService) {
    }

    ngOnInit() {
        this._session.profileAsObservable.subscribe(result => {
            if (result instanceof Cliente) {
                if (result.usuario.passwordValidUntil && result.usuario.passwordValidUntil > moment.now()) {
                    this.router.navigateByUrl('/password-reset').then();
                }
            }
        })

        this.route.queryParamMap.subscribe(params => {
            if (params.get('h') === null) {
                return;
            }
            this.hashService.decodeHash('decode?h=' + params.get('h')).subscribe(url => {
                this.router.navigateByUrl(url).then();
            }, error => {
                this.router.navigateByUrl('/inicio').then();
            })
        })
    }

    irA(link: string | null) {
        if (link) {
            this.router.navigateByUrl(link).then()
        }
    }
}
